const marketShareIDs = {
  categoryId: "f128b036-62bc-403d-b0cb-596f22297d36",

  commercialOrgReportId: "533cbc45-b59e-43f8-971f-545dd470720e",
  commercialPhysReportId: "4036f04b-92b7-411c-aac4-a0bf1fd51f70",

  medicareOrgReportId: "45159a32-5d21-4b2d-adcf-5694277d9cd6",
  medicarePhysReportId: "2207e944-58d2-4527-8d09-4d77f802f688",

  allpayerOrgReportId: "ff8db8c1-b8e8-4c23-b19f-cd4f81ae652c",
  allpayerPhysReportId: "926e8c94-b7d8-4ab6-a75c-827edbbe7dfc"
};

const clinicalMarketShareIDs = {
  categoryId: "f891fb88-95e5-4358-9dc7-c49848a0ccd8",

  commercialOrgReportId: "be10dc48-0e48-4188-aa98-7694a426e785",
  commercialPhysReportId: "adb75097-c2d4-4aa5-9879-069659a2259f",

  medicareOrgReportId: "d0cfec74-e1d2-47f3-a5bc-8fffbdbddea5",
  medicarePhysReportId: "eb9fb42a-ca03-48fb-9b41-639909d17ab1",

  allpayerPhysProcedureReportId: "1eaa8b66-c2ec-4c84-8afe-67dede57b393",
  allpayerPhysPrimaryDiagnosisReportId: "af4fbb9e-3733-4a48-9aa1-a42492045c4c",
  allpayerPhysMSDRGReportId: "5e49e1e7-2205-460d-aa57-10f256759525",

  allpayerOrgProcedureReportId: "18576a91-905b-43a1-9326-25f72911c891",
  allpayerOrgPrimaryDiagnosisReportId: "345a9786-5fc1-436b-b148-37f0d171dde3",
  allpayerOrgMSDRGReportId: "5d6f6cb7-31ca-4386-9734-bc4ea2391eff"
};

const populationTrackerIDs = {
  categoryId: "8ad8fedc-a1cd-4e0b-ba7a-30d59e6e5f98",

  orgReportId: "50d73a57-6a47-4af9-869b-9e4b1d8c7f6b",
  orgSourceReportId: "1a8da9cb-49c1-46ed-96c0-543af598fc5f",

  physReportId: "c95aabf3-bc03-4b12-8b30-111af93a2f69",
  physSourceReportId: "574706dd-72f8-4d42-a1db-6f4c0bc37a29"
};

const trendedPOSIDs = {
  categoryId: "246c5d26-7850-4101-8944-68a3e3119ba3",
  reportId: "38d9a632-2dd6-4693-9da4-d4e119f7c8be"
};

const placeOfServiceIDs = {
  categoryId: "4c526dbe-10dd-49bb-a444-04a0adca08cc",

  physReportId: "6c72cf00-a498-467b-b872-668d56b4d57d",
  orgReportId: "fc092612-4475-4eae-aa0f-50d949b58a48"
};

const placeOfServiceByCountyIDs = {
  categoryId: '19e62af0-0c09-4042-bfb5-5cefe113f144',
  reportId: '4411190a-5f46-457d-848d-891ea114c8d1'
};

const billingReportIDs = {
  categoryId: "2c216183-eb2d-4921-ad24-c9bb3556f428",
  reportId: "9bd13e88-dedd-4003-92da-99b354647f7f"
};

const countyLevelServicesIDs = {
  categoryId: "a5b8b2d4-93c9-47a0-b132-0fed4f6d2289",

  msdrgReportId: "f672e664-56cd-4167-a1ae-0dcc367b4a6a",
  cpthcpcsReportId: "01340732-f3f7-439a-88b2-dda036f3a929",
  primaryDiagnosisReportId: "3de58332-2f28-472f-a65c-f487aa1e52d4"
};

const shareOfCareIDs = {
  categoryId: "320ff5ec-097e-4371-82a4-e3cc2623dc53",

  orgReportId: "7905e506-241d-43c3-bdab-794163c569b6",
  orgSourceReportId: "a217faab-46cb-41d4-8a00-1145bf936d55",

  physReportId: "6db28d87-3618-43ec-9bae-7f2e187291f0",
  physSourceReportId: "db25c2d2-9fe8-4a47-ada2-2b5359a08940"
};

const clinicalVolumesIDs = {
  categoryId: "bc41672f-b834-4826-864e-549c4586edc6",

  orgReportId: "c8456d4c-a5ca-4f52-9da0-659655d64ab2",
  physReportId: "a7e026e6-0084-4054-9456-3215970f3a0f"
};

const campaignEffectivenessIDs = {
  categoryId: "4c6dc426-0ba0-4cee-986f-a6800bc9c666",

  reportId: "1d4b58e6-37e9-4e55-a8c0-580540a5ac76",
  allNpisReportId: "561ebe24-cbb5-4bde-af62-7bab01521b38"
};

export {
  marketShareIDs,
  clinicalMarketShareIDs,
  populationTrackerIDs,
  trendedPOSIDs,
  placeOfServiceIDs,
  placeOfServiceByCountyIDs,
  billingReportIDs,
  countyLevelServicesIDs,
  shareOfCareIDs,
  clinicalVolumesIDs,
  campaignEffectivenessIDs
};
